import { createElementBlock as o, openBlock as r, createElementVNode as l } from "vue";
const n = {
  fill: "none",
  viewBox: "0 0 21 21"
};
function t(a, e) {
  return r(), o("svg", n, [...e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      d: "M12.726 6.452h-1.518v-.96a.708.708 0 1 0-1.416 0v.96h-.166a1.942 1.942 0 0 0-2.06 2.066c.014.707.54 1.227.963 1.563.459.364 1.053.707 1.588 1.016l.03.017c.57.329 1.075.622 1.443.914.406.323.428.479.428.484v.013a.596.596 0 0 1-.606.606H8.274a.708.708 0 1 0 0 1.417h1.518v.961a.708.708 0 0 0 1.416 0v-.961h.185a2.014 2.014 0 0 0 2.041-2.043c-.003-.719-.535-1.246-.963-1.586-.459-.364-1.053-.707-1.588-1.016l-.03-.017c-.57-.329-1.075-.622-1.443-.914-.406-.323-.428-.478-.428-.484q0-.027-.002-.056a.525.525 0 0 1 .565-.565l.056.002h3.125a.708.708 0 0 0 0-1.417"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.5 2a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17M5.491 5.491A7.083 7.083 0 1 1 15.51 15.51 7.083 7.083 0 0 1 5.49 5.49Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const d = { render: t };
export {
  d as default,
  t as render
};
